// Card post: vote on the card, then share it as a PNG.
// Reads the card from the JSON data block with id ogg-card-data.
(function () {
  var dataEl = document.getElementById('ogg-card-data');
  if (!dataEl) return;
  var CARD = JSON.parse(dataEl.textContent);
  var picked = null;
  var status = document.getElementById('ogg-share-status');
  var list = document.getElementById('ogg-choices');
  var buttons = Array.prototype.slice.call(list.querySelectorAll('.ogg-card__choice'));

  buttons.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      picked = i;
      buttons.forEach(function (b) { b.disabled = true; });
      btn.classList.add('is-cut');
      list.classList.add('is-done');
      var stamp = document.createElement('span');
      stamp.className = 'ogg-card__stamp';
      stamp.setAttribute('aria-hidden', 'true');
      stamp.textContent = 'GONE';
      document.getElementById('ogg-card').appendChild(stamp);
      var note = document.getElementById('ogg-note');
      var mini = document.getElementById('ogg-mini');
      if (mini) {
        // the mini buy card carries the call to action
        note.textContent = 'Good pick! Now tell your friends why.';
        mini.hidden = false;
      } else {
        note.textContent = 'Good pick! Now tell your friends why. ';
        if (CARD.buyUrl) {
          var buy = document.createElement('a');
          buy.href = CARD.buyUrl;
          buy.innerHTML = 'Get the game for your next game night &rarr;';
          note.appendChild(buy);
        }
      }
      document.getElementById('ogg-share-sub').textContent = 'Your pick is stamped on the image. Send it and make them choose.';
    });
  });

  // Phone buy bar: show once the card has scrolled away, hide while the full buy box is on screen.
  var sticky = document.getElementById('ogg-sticky');
  var cardEl = document.getElementById('ogg-card');
  var buyBox = document.getElementById('ogg-buy');
  if (sticky && cardEl && 'IntersectionObserver' in window) {
    var pastCard = false, boxVisible = false;
    var update = function () {
      var show = pastCard && !boxVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pastCard = !e.isIntersecting && e.boundingClientRect.top < 0;
      update();
    }).observe(cardEl);
    if (buyBox) new IntersectionObserver(function (entries) { boxVisible = entries[0].isIntersecting; update(); }).observe(buyBox);
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function spacing(ctx, v) { if ('letterSpacing' in ctx) ctx.letterSpacing = v; }

  // 1080x1350 portrait: fits Instagram, Facebook and group chats.
  // Same layout as scripts/card-posts/render-png.mjs.
  function drawCard() {
    var W = 1080, H = 1350, c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d');
    var HEAD = '"Bebas Neue", Impact, sans-serif', BODY = '"DM Sans", Arial, sans-serif';
    ctx.fillStyle = '#f5c842'; ctx.fillRect(0, 0, W, H);

    var x = 90, y = 100, w = W - 180, h = 990;
    ctx.fillStyle = '#0a0a0a'; roundRect(ctx, x + 18, y + 18, w, h, 36); ctx.fill();
    ctx.fillStyle = '#ffffff'; roundRect(ctx, x, y, w, h, 36); ctx.fill();
    ctx.lineWidth = 8; ctx.strokeStyle = '#0a0a0a'; roundRect(ctx, x, y, w, h, 36); ctx.stroke();

    ctx.fillStyle = 'rgba(10,10,10,0.5)'; ctx.font = '34px ' + HEAD; spacing(ctx, '8px');
    ctx.fillText(CARD.category.toUpperCase(), x + 70, y + 110);
    spacing(ctx, '2px'); ctx.fillStyle = '#0a0a0a';
    var size = 84, title = CARD.title.toUpperCase();
    do { ctx.font = size + 'px ' + HEAD; size -= 2; } while (ctx.measureText(title).width > w - 140 && size > 40);
    ctx.fillText(title, x + 70, y + 205);
    ctx.fillStyle = '#d4a017'; ctx.font = '60px ' + HEAD;
    ctx.fillText('ONE GOTTA GO!', x + 70, y + 275);
    spacing(ctx, '0px');

    var by = y + 330, bh = 128, gap = 26, bx = x + 70, bw = w - 140;
    CARD.choices.forEach(function (ch, i) {
      var top = by + i * (bh + gap), cut = picked === i;
      ctx.fillStyle = cut ? 'rgba(230,51,41,0.10)' : '#ffffff'; ctx.fillRect(bx, top, bw, bh);
      ctx.lineWidth = 5; ctx.strokeStyle = cut ? '#e63329' : '#0a0a0a'; ctx.strokeRect(bx, top, bw, bh);
      ctx.fillStyle = cut ? '#e63329' : '#0a0a0a';
      ctx.font = '56px ' + HEAD; ctx.fillText(ch.letter, bx + 34, top + 84);
      var t = ch.emoji + ' ' + ch.text, tx = bx + 100, maxW = bw - 130;
      ctx.font = '500 38px ' + BODY;
      var lines = [t];
      if (ctx.measureText(t).width > maxW) {
        ctx.font = '500 34px ' + BODY;
        var words = t.split(' '), a = '', k = 0;
        while (k < words.length && ctx.measureText((a ? a + ' ' : '') + words[k]).width <= maxW) { a += (a ? ' ' : '') + words[k]; k++; }
        var rest = words.slice(k).join(' ');
        lines = rest ? [a, rest] : [a];
      }
      var bases = lines.length === 1 ? [top + 78] : [top + 56, top + 100];
      lines.forEach(function (ln, j) {
        ctx.fillText(ln, tx, bases[j]);
        if (cut) ctx.fillRect(tx, bases[j] - (lines.length === 1 ? 14 : 12), ctx.measureText(ln).width, 5);
      });
    });

    if (picked !== null) {
      ctx.save();
      ctx.translate(x + w - 110, y + 60); ctx.rotate(0.21);
      ctx.font = '76px ' + HEAD; spacing(ctx, '6px');
      var sw = ctx.measureText('GONE').width + 50;
      ctx.fillStyle = '#0a0a0a'; ctx.fillRect(-sw / 2 + 8, -52, sw, 104);
      ctx.fillStyle = '#ffffff'; ctx.fillRect(-sw / 2, -60, sw, 104);
      ctx.lineWidth = 7; ctx.strokeStyle = '#e63329'; ctx.strokeRect(-sw / 2, -60, sw, 104);
      ctx.fillStyle = '#e63329'; ctx.textAlign = 'center'; ctx.fillText('GONE', 3, 20);
      ctx.restore();
    }

    ctx.textAlign = 'center'; ctx.fillStyle = '#0a0a0a';
    spacing(ctx, '3px'); ctx.font = '64px ' + HEAD;
    ctx.fillText(picked === null ? 'WHICH ONE WOULD YOU CUT?' : 'I CUT ' + 'ABCD'[picked] + '. WHAT ABOUT YOU?', W / 2, 1210);
    spacing(ctx, '1px');
    var addr = CARD.url.replace(/^https?:\/\//, ''), fs = 36;
    do { ctx.font = '700 ' + fs + 'px ' + BODY; fs -= 2; } while (ctx.measureText(addr).width > W - 120 && fs > 20);
    ctx.fillText(addr, W / 2, 1272);
    return c;
  }

  function makePng() {
    var fonts = document.fonts ? Promise.all([
      document.fonts.load('84px "Bebas Neue"'),
      document.fonts.load('500 38px "DM Sans"'),
      document.fonts.load('700 36px "DM Sans"')
    ]) : Promise.resolve();
    return fonts.then(function () {
      return new Promise(function (res, rej) {
        drawCard().toBlob(function (b) { b ? res(b) : rej(new Error('PNG failed')); }, 'image/png');
      });
    });
  }

  var FILE_NAME = 'one-gotta-go-' + CARD.slug + '.png';

  document.getElementById('ogg-download').addEventListener('click', function () {
    makePng().then(function (blob) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = FILE_NAME;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
      status.textContent = 'Saved. Post it or drop it in the group chat.';
    }).catch(function () { status.textContent = 'Could not make the image. Try again.'; });
  });

  var nativeBtn = document.getElementById('ogg-share-native');
  var testFile = window.File ? new File([''], FILE_NAME, { type: 'image/png' }) : null;
  if (navigator.canShare && testFile && navigator.canShare({ files: [testFile] })) nativeBtn.hidden = false;
  nativeBtn.addEventListener('click', function () {
    makePng().then(function (blob) {
      return navigator.share({
        files: [new File([blob], FILE_NAME, { type: 'image/png' })],
        title: CARD.title + ': One Gotta Go',
        text: 'Which one would you cut? ' + CARD.url
      });
    }).catch(function (e) { if (e && e.name !== 'AbortError') status.textContent = 'Sharing did not work here. Use Save as PNG instead.'; });
  });

  document.getElementById('ogg-copy').addEventListener('click', function () {
    var done = function () { status.textContent = 'Link copied.'; };
    if (navigator.clipboard) navigator.clipboard.writeText(CARD.url).then(done, function () { status.textContent = CARD.url; });
    else status.textContent = CARD.url;
  });
})();
